import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface UIState {
  sidebarCollapsed: boolean;
  currentLanguage: string;
  currentTheme: 'light' | 'dark';
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setLanguage: (language: string) => void;
  setTheme: (theme: 'light' | 'dark') => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      currentLanguage: 'pt',
      currentTheme: 'light',

      toggleSidebar: () => {
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed }));
      },

      setSidebarCollapsed: (collapsed: boolean) => {
        set({ sidebarCollapsed: collapsed });
      },

      setLanguage: (language: string) => {
        set({ currentLanguage: language });
      },

      setTheme: (theme: 'light' | 'dark') => {
        set({ currentTheme: theme });
      }
    }),
    {
      name: 'ui-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
);